<template>
  <div>
    <el-row>
      <el-col :span="23">
        <el-form-item :label="labelText(zdItem.label)">
          <el-select
            v-model="zdFormattedValue"
            :placeholder="$t('view.select_placeholder')"
            :disabled="setupDisable() || getAuthShow()"
            @change="selectChange"
            style="width: 100%"
          >
            <el-option
              v-for="(option, index) in zdItem.options_value"
              :key="index"
              :label="setupOptionValue(option.label)"
              :value="option.label"
              :disabled="option.disabled"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="1">
        <el-button size="medium" @click="clearValue">{{ $t("content.clear") }}</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import base from "@/common/base.js";
export default {
  name: "ZDSelect",
  props: {
    zdId: {
      type: String,
      required: true,
    },
    pageStatus: {
      type: String,
      default: "Add",
    },
  },
  inject: ["productTypeChange", "getCurrentDataMethod"],
  computed: {
    // 从 Vuex 获取当前组件的整个状态
    ...mapGetters("zdInput", {
      zdGetComponentState: "getComponentState",
    }),
    // 获取当前组件的状态对象
    zdComponentState() {
      return this.zdGetComponentState(this.zdId) || {};
    },
    // 从状态对象中获取各个字段
    zdItem() {
      return this.zdComponentState;
    },
    labelText() {
      return (label) => {
        let key = "content." + label;
        key = key.toLowerCase().replaceAll(" ", "_");
        return this.$t(key);
      };
    },
    zdFormattedValue: {
      get() {
        return this.zdItem.value || ""; // 获取输入框的值
      },
      set(value) {
        this.zdUpdateComponent({
          id: this.zdId,
          field: "value",
          value: value,
        }); // 更新输入框的值
      },
    },
  },
  created() {
    // console.log("created:", this.zdItem);

    // 监听页面状态变化
    this.$EventBus.$on("pageStatusChange", this.handlePageStatusChange);
    this.$EventBus.$on("tabChanged", this.handleTabChanged);
  },

  beforeDestroy() {
    // 清理事件监听器
    this.$EventBus.$off("pageStatusChange", this.handlePageStatusChange);
    this.$EventBus.$off("tabChanged", this.handleTabChanged);
  },
  methods: {
    // 映射 Vuex 的动作
    ...mapActions("zdInput", ["updateComponent"]),

    /**
     * 处理页面状态变化
     */
    handlePageStatusChange() {
      // console.info("ZDSelect: Page status changed to", pageStatus, "for component", this.zdId);

      // 强制组件重新计算disabled状态
      this.$forceUpdate();
    },
    clearValue() {
      this.zdFormattedValue = "";
    },

    /**
     * 处理标签页变化
     */
    handleTabChanged() {
      // console.info("ZDSelect: Tab changed to", data.tabName, "with status", data.pageStatus, "for component", this.zdId);

      // 强制组件重新计算disabled状态
      this.$forceUpdate();
    },

    zdUpdateComponent(payload) {
      this.updateComponent(payload); // 更新组件状态
    },
    getAuthShow() {
      return base.getAuthShow();
    },
    selectChange(value) {
      this.zdUpdateComponent({
        id: this.zdId,
        field: "value",
        value: value,
      });

      // console.info('this.zdItem.label==:',value)
      if (this.zdItem.label === "Product Type") {
        const currentData = this.getCurrentDataMethod();
        currentData.productType = value;
        this.productTypeChange(value);
      }

      // 处理Shelflife Number的变化
      if (this.zdItem.label === "Shelflife Number") {
        // 将shelflife_number保存到localStorage，以便ZDDate组件使用
        // localStorage.setItem("shelflife_number", value);
      }
    },
    setupOptionValue(val) {
      if (this.zdItem.label === "Shelflife Number") {
        return val + " months";
      }
      return val;
    },
    setupDisable() {
      let type = this.$route.query.type;
      const pageStatus = this.pageStatus;

      // 如果页面状态是Detail，所有字段都不可编辑
      if (pageStatus === "Detail") {
        return true;
      }

      // 如果页面状态是Edit，根据字段配置和业务规则决定是否可编辑
      if (type === "coa" && pageStatus === "Edit") {
        let tmpArr = ["product_name", "customer_product_name", "product_type"];
        let key = this.zdItem.label.toLowerCase().replaceAll(" ", "_");
        if (tmpArr.includes(key)) {
          return true;
        }
      }

      // 返回字段本身的disabled配置
      return this.zdItem.disabled || false;
    },
  },
};
</script>
